
import React from "react";
import { Badge } from "@/components/ui/badge";
import { X } from "lucide-react";

interface IngredientBadgeProps {
  ingredient: string;
  onRemove: (ingredient: string) => void;
  variant?: "default" | "secondary" | "destructive";
}

const IngredientBadge: React.FC<IngredientBadgeProps> = ({
  ingredient,
  onRemove,
  variant = "default"
}) => {
  return (
    <Badge
      key={ingredient}
      variant={variant}
      className="flex items-center gap-1 pr-1"
    >
      {ingredient}
      <X
        className="h-3 w-3 cursor-pointer"
        onClick={() => onRemove(ingredient)}
      />
    </Badge>
  );
};

export default IngredientBadge;
